import { Component, computed, effect, output } from "@angular/core";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/ngrx/reducers";
import { InstructionDetailsSelectors } from "src/app/ngrx/selectors";
import { LoadingIndicatorComponent } from "../../utils/loading-indicator/loading-indicator.component";
import { Chapter } from "src/app/models/instruction/chapter";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-chapters",
  imports: [LoadingIndicatorComponent, TranslatePipe],
  templateUrl: "./chapters.component.html",
  styles: ``,
})
export class ChaptersComponent {
  chapters = this.store.selectSignal(InstructionDetailsSelectors.chapters);
  instruction = this.store.selectSignal(
    InstructionDetailsSelectors.myInstruction,
  );

  sortedChaptersWithConfirmations = computed(() => {
    const chapters = this.chapters();
    const sortedChapters = [...chapters.chapters].sort(
      (a, b) => a.order - b.order,
    );

    return {
      chapterWithConfirmation: sortedChapters.map((chapter) => ({
        chapter: chapter,
        chapterConfirmation: chapters.chapterConfirmations.find(
          (chapterConfirmation) => chapterConfirmation.chapter == chapter.name,
        ),
      })),
      isLoadingChapters: this.chapters().isLoadingChapters,
    };
  });

  showProgress = computed(() => {
    const instruction = this.instruction();
    return (
      !instruction.isLoadingMyInstruction &&
      instruction.myInstruction &&
      instruction.myInstruction.type != "Information" // we only show the progress when the type is not information
    );
  });

  chapterStats = computed(() => {
    const chaptersWithConfirmation =
      this.sortedChaptersWithConfirmations().chapterWithConfirmation;

    const confirmedChapters = chaptersWithConfirmation.filter(
      (pair) => pair.chapterConfirmation != undefined,
    ).length;

    const chapters = chaptersWithConfirmation.length;

    return {
      confirmedChapters: confirmedChapters,
      confirmedPercentage: Math.ceil((confirmedChapters / chapters) * 100),
      chapters: chapters,
    };
  });

  chapterSelected = output<Chapter>();
  selectedChapter: Chapter | undefined;

  constructor(private readonly store: Store<AppState>) {
    effect(() => {
      const sortedChapters = this.sortedChaptersWithConfirmations();
      if (
        !this.selectedChapter &&
        sortedChapters.chapterWithConfirmation.length > 0
      ) {
        this.selectChapter(sortedChapters.chapterWithConfirmation[0].chapter);
      }
    });
  }

  selectChapter(chapter: Chapter) {
    this.selectedChapter = chapter;
    this.chapterSelected.emit(chapter);
  }
}
